import Form from './Form';

export default class SettingsForm extends Form {
    templateId() {
        return '#settingsFormTemplate';
    }

    data() {
        return '/dashboard/profile/ajax/settings/get';
    }

    load(containerId, componentId) {
        return super.load(containerId, componentId).then(function () {
            $('select').each(function () {
                var selectValue = $(this).closest('.selectContainer').find('.selectValue');
                $(this).ddslick({
                    onSelected: function (data) {
                        selectValue.val(data.selectedData.value);
                    }
                });
            });
        });
    }
}
